export const missions = {
  B1:  { name: "Voyager 1", date: "1977", significance: "major outer planet mission; farthest human made object" },
  C1:  { name: "Explorer 1", date: "1958", significance: "first U.S. satellite; began U.S. space science" },

  B2:  { name: "Hubble Space Telescope", date: "1990", significance: "transformative space telescope for astronomy" },
  C2:  { name: "Voyager 2", date: "1977", significance: "only mission to visit four outer planets" },

  B3:  { name: "Viking 1", date: "1975", significance: "first successful U.S. Mars landing" },
  C3:  { name: "James Webb Space Telescope", date: "2021", significance: "powerful observatory for deep space and exoplanets" },

  B4:  { name: "Galileo", date: "1989", significance: "first spacecraft to orbit Jupiter" },
  C4:  { name: "Cassini", date: "1997", significance: "landmark mission to Saturn and its moons" },

  B5:  { name: "Mars Pathfinder", date: "1996", significance: "delivered the first Mars rover" },
  C5:  { name: "Mariner 2", date: "1962", significance: "first successful mission to another planet" },

  B6:  { name: "Mariner 9", date: "1971", significance: "first spacecraft to orbit another planet" },
  C6:  { name: "Mariner 4", date: "1964", significance: "first close up images of Mars" },

  B7:  { name: "New Horizons", date: "2006", significance: "first mission to Pluto" },
  C7:  { name: "Magellan", date: "1989", significance: "mapped Venus with radar" },

  B8:  { name: "Perseverance", date: "2020", significance: "advanced Mars astrobiology and sample collection" },
  C8:  { name: "Curiosity", date: "2011", significance: "showed ancient Mars could support life" },

  B9:  { name: "Pioneer 11", date: "1973", significance: "first spacecraft to fly past Saturn" },
  C9:  { name: "Pioneer 10", date: "1972", significance: "first mission through the asteroid belt to Jupiter" },

  B10: { name: "Lunar Reconnaissance Orbiter", date: "2009", significance: "produced detailed modern maps of the Moon" },
  C10: { name: "Surveyor 1", date: "1966", significance: "first successful U.S. soft landing on the Moon" },

  B11: { name: "Mars Reconnaissance Orbiter", date: "2005", significance: "high resolution Mars imaging and relay mission" },
  C11: { name: "Ranger 7", date: "1964", significance: "first successful close lunar imaging mission" },

  B12: { name: "Juno", date: "2011", significance: "revealed Jupiter's deep structure and atmosphere" },
  C12: { name: "Mars Global Surveyor", date: "1996", significance: "rebuilt Mars mapping and orbital science" },

  B13: { name: "Kepler", date: "2009", significance: "proved planets are common across the galaxy" },
  C13: { name: "Parker Solar Probe", date: "2018", significance: "first mission to fly through the Sun's corona" },

  B14: { name: "WMAP", date: "2001", significance: "refined the age and structure of the universe" },
  C14: { name: "COBE", date: "1989", significance: "helped confirm the Big Bang model" },

  B15: { name: "Spitzer Space Telescope", date: "2003", significance: "transformative infrared space telescope" },
  C15: { name: "Chandra X ray Observatory", date: "1999", significance: "major observatory for high energy astronomy" },

  B16: { name: "Swift", date: "2004", significance: "changed the study of gamma ray bursts" },
  C16: { name: "TESS", date: "2018", significance: "found planets around nearby stars" },

  B17: { name: "IRAS", date: "1983", significance: "first all sky infrared survey" },
  C17: { name: "WISE", date: "2009", significance: "major infrared sky survey mission" },

  B18: { name: "Ulysses", date: "1990", significance: "first mission to study the Sun's poles" },
  C18: { name: "SOHO", date: "1995", significance: "landmark solar observatory" },

  B19: { name: "Dawn", date: "2007", significance: "first spacecraft to orbit two different worlds" },
  C19: { name: "STEREO", date: "2006", significance: "first 3D views of the Sun" },

  B20: { name: "OSIRIS REx", date: "2016", significance: "first U.S. asteroid sample return mission" },
  C20: { name: "MESSENGER", date: "2004", significance: "first spacecraft to orbit Mercury" },

  B21: { name: "Deep Impact", date: "2005", significance: "studied material inside a comet" },
  C21: { name: "Stardust", date: "1999", significance: "returned samples from a comet" },

  B22: { name: "Phoenix", date: "2007", significance: "confirmed water ice on Mars" },
  C22: { name: "NEAR Shoemaker", date: "1996", significance: "first spacecraft to orbit and land on an asteroid" },

  B23: { name: "MAVEN", date: "2013", significance: "showed how Mars lost much of its atmosphere" },
  C23: { name: "InSight", date: "2018", significance: "measured marsquakes and Mars's interior" },

  B24: { name: "Landsat 1", date: "1972", significance: "began long term Earth land imaging" },
  C24: { name: "2001 Mars Odyssey", date: "2001", significance: "long running Mars orbiter and relay mission" },

  B25: { name: "Terra", date: "1999", significance: "major Earth system science mission" },
  C25: { name: "TIROS 1", date: "1960", significance: "first successful weather satellite" },

  B26: { name: "Aqua", date: "2002", significance: "advanced climate and water cycle science" },
  B27: { name: "GRACE", date: "2002", significance: "measured changes in Earth's gravity, water, and ice" },
  B28: { name: "ICESat 2", date: "2018", significance: "measured ice sheets and elevation change" },
  B29: { name: "Nimbus 7", date: "1978", significance: "important atmosphere and ozone mission" },
  B30: { name: "TOPEX Poseidon", date: "1992", significance: "revolutionized sea level measurement" },
  B31: { name: "DSCOVR", date: "2015", significance: "important space weather and Earth viewing mission" },
  B32: { name: "MMS", date: "2015", significance: "major mission for magnetic reconnection" },
  B33: { name: "Wind", date: "1994", significance: "long running solar wind research mission" },
  B34: { name: "Clementine", date: "1994", significance: "restarted modern U.S. lunar exploration" },
  B35: { name: "Europa Clipper", date: "2024", significance: "studies Europa's habitability" },
  B36: { name: "Lunar Orbiter 1", date: "1966", significance: "first U.S. lunar orbiter; mapped Apollo landing areas" },
  B37: { name: "Lunar Prospector", date: "1998", significance: "strengthened evidence for water ice at the Moon's poles" },
  B38: { name: "GRAIL", date: "2011", significance: "mapped the Moon's gravity field in high detail" },
  B39: { name: "LCROSS", date: "2009", significance: "confirmed water ice in a permanently shadowed lunar crater" },
  B40: { name: "NuSTAR", date: "2012", significance: "first focusing high energy X ray space telescope" },
  B41: { name: "Uhuru", date: "1970", significance: "first dedicated X ray astronomy satellite" },
  B42: { name: "OAO 2", date: "1968", significance: "early major ultraviolet space observatory" },
  B43: { name: "ACE", date: "1997", significance: "long running mission for solar particles and space weather" },
  B44: { name: "IMAGE", date: "2000", significance: "first global images of Earth's magnetosphere" },
  B45: { name: "Einstein Observatory (HEAO 2)", date: "1978", significance: "first fully imaging X ray telescope in space" },
};

export function getMissionByNode(nodeId) {
  return missions[nodeId] || null;
}
